import { styled } from "@mui/material";
import ChatbotIcon from "./ChatbotIcon";

const QuestionWrapper = styled("div")({
  alignSelf: "flex-start",
  padding: "5px 10px",
  margin: "0 10px",
  display: "flex",
  flexDirection: "row",
  "& p": {
    marginLeft: "5px",
    marginTop: "inherit",
    backgroundColor: "#FAE3C7",
    padding: "10px",
    margin: "5px 10px",
    borderRadius: "1rem",
    wordBreak: "break-word",
  },
});

const ChatbotQuestionUnstyled = ({ text, className }) => {
  return (
    text && (
      <QuestionWrapper className={className}>
        <ChatbotIcon
          sx={{
            marginTop: "8px",
            fontSize: "2rem",
            color: "#EC9D3E",
          }}
        />
        <p dangerouslySetInnerHTML={{ __html: text }} />
      </QuestionWrapper>
    )
  );
};

const ChatbotQuestion = styled(ChatbotQuestionUnstyled)({});

export default ChatbotQuestion;
